import { render, staticRenderFns } from "./ManagementReports.vue?vue&type=template&id=42ec32d0&scoped=true&"
import script from "./ManagementReports.vue?vue&type=script&lang=ts&"
export * from "./ManagementReports.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementReports.vue?vue&type=style&index=0&id=42ec32d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec32d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCol,VContainer,VIcon,VProgressCircular,VRow,VTab,VTabs})
